import { ComponentType } from 'react';

const enUSComponents: Record<string, ComponentType> = {};

export default enUSComponents;
